// Simple grid view for raw materials (optional, for UI consistency)
import React from "react";
import ProductCard from '../../CommonComponents/ProductCard';


const RawMaterialGrid = ({ materials, onEdit, onDelete, uploadsBaseURL }) => (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {materials.map((mat) => (
            <ProductCard
                key={mat.id}
                product={{
                    id: mat.id,
                    name: mat.name,
                    stock: mat.quantity,
                    unitType: mat.unit,
                    image: mat.image_url ? `${uploadsBaseURL}/${mat.image_url}` : undefined,
                    // No price for raw materials
                    // No description for raw materials
                    created_at: mat.created_at,
                    updated_at: mat.updated_at,
                }}
                onEdit={() => onEdit(mat)}
                onDelete={() => onDelete(mat)}
                showActionsOnly={true}
                showQuantityControl={false}
                showUnitType={true}
                showAddToCart={false}
                showOutOfStockLabel={false}
                uploadsBaseURL={null}
                showPriceBadge={false}
                showStockBadge={false}
                showDescription={false}
            />
        ))}
    </div>
);

export default RawMaterialGrid;
